var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.$emit('submit')}}},[_vm._t("default"),_c('div',{staticClass:"text-center"},[(!!_vm.error)?_c('FormError',{attrs:{"text":_vm.error}}):_vm._e()],1),_vm._t("button")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }